import 'css/src/components/common/BeamerUpdates';

import React from 'react';
import { Helmet } from 'react-helmet';

type Props = {
    onBeamerLoad: (numUnreads: number) => void;
};

const BEAMER_SELECTOR_ID = 'beamer-updates';

export const showBeamer = (_retry_count = 0) => {
    if (_retry_count > 20) {
        return;
    }
    if (window.Beamer) {
        window.Beamer.show();
    }

    window.setTimeout(() => {
        // if react re-renders, the beamer content gets removed from the DOM.
        // Here, we just check if the beamer stuff is in the DOM. If not,
        // just call the function recursively.
        const beamerContainer = document.getElementById(BEAMER_SELECTOR_ID);
        if (beamerContainer && beamerContainer.childElementCount === 0) {
            showBeamer(_retry_count + 1);
        }
    }, 200);
};

/**
 * This is a section of the app that shows the Product Updates.
 * It is hooked up to Beamer, our service for product updates.
 * https://app.getbeamer.com/
 *
 * NOTE: it's assumed that this button appears a maximum of ONE time per page. If we want to show it multiple times
 *       (not sure why, but if!) then we need to take care to not load the Beamer JS multiple times.
 */
const BeamerUpdates = React.memo(function BeamerUpdates({ onBeamerLoad }: Props) {
    React.useEffect(() => {
        // set up global beamer config
        window.beamer_config = {
            product_id: 'FpQaVqbY44322',
            filter_by_url: true,
            selector: `#${BEAMER_SELECTOR_ID}`,
            embed: true,
            alert: false,
            callback: (numUnreads: number) => {
                onBeamerLoad(numUnreads);
            },
        };
        if (SERVER.ANALYTICS) {
            // logged in user, attach non-identifying properties
            window.beamer_config = {
                ...window.beamer_config,
                user_id: SERVER.ANALYTICS.id,
                created_at: SERVER.ANALYTICS.created,
                plan_name: SERVER.ANALYTICS.plan_name,
                video_count: SERVER.ANALYTICS.video_count,
                downloaded_video_count: SERVER.ANALYTICS.downloaded_video_count,
                business_name: SERVER.ANALYTICS.business_name,
                workspace_count: SERVER.ANALYTICS.workspace_count,
                feature_flags: SERVER.USER?.feature_flags?.join(','),
            };
        }
    }, [onBeamerLoad]);

    return (
        <Helmet>
            <script
                type="text/javascript"
                src="https://app.getbeamer.com/js/beamer-embed.js"
                defer={true}
            />
        </Helmet>
    );
});

export default BeamerUpdates;
